import { render, staticRenderFns } from "./AutoApprovalSuccessMessage.vue?vue&type=template&id=5b6ba1dc&scoped=true"
import script from "./AutoApprovalSuccessMessage.vue?vue&type=script&lang=ts"
export * from "./AutoApprovalSuccessMessage.vue?vue&type=script&lang=ts"
import style0 from "./AutoApprovalSuccessMessage.vue?vue&type=style&index=0&id=5b6ba1dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6ba1dc",
  null
  
)

export default component.exports